
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
  import TourOverlay from './TourOverlay.vue'
  import TourPopover from './TourPopover.vue'
  import { TourStep as ITourStep, TourOptions } from '../models/interfaces'

@Component({
  components: {
    TourOverlay,
    TourPopover,
  },
})
  export default class TourStep extends Vue {
  @Prop({ type: Object, required: true }) step!: ITourStep;
  @Prop({ type: Number, default: 0 }) stepIndex!: number;
  @Prop({ type: Number, required: true }) totalSteps!: number;
  @Prop({ type: Boolean, default: false }) isActive!: boolean;
  @Prop({ type: Number, default: 0.5 }) backdropOpacity!: number;
  @Prop({ type: Object, default: () => ({}) }) options!: TourOptions;

  @Watch('isActive')
  async onActiveChange (isActive: boolean) {
    if (isActive && this.step.action) {
      this.step.action()
    }
  }

  /**
   * Maneja el click de siguiente
   */
  handleNext () {
    this.$emit('next')
  }

  /**
   * Maneja el click de anterior
   */
  handlePrev () {
    this.$emit('prev')
  }

  /**
   * Maneja el click de omitir
   */
  handleSkip () {
    this.$emit('skip')
  }
  }
